module.exports = __webpack_public_path__ + "static/media/settings.7ddd8ec6.jpg";